import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import { take } from 'rxjs';

import { SearchFilters, SearchSortOrder, SearchType } from '../model/search-filter';
import { resolveDateFilterParam, resolveFilterParam } from '../service/search-api.utils';
import { DataAccessSearchFacade } from '../state/search-results/data-access-search.facade';

@Injectable()
export class SearchResolver {
  static searchTypeParam = 'searchTypes';
  static searchTermParam = 'searchTerm';
  static searchPageParam = 'page';
  static searchSortParam = 'sort';
  static searchStringFilterParam = 'filter';
  static searchDateFilterParam = 'dateFilter';

  constructor(private searchFacade: DataAccessSearchFacade, private fairsFacade: DataAccessFairsFacade) {}

  resolve(route: ActivatedRouteSnapshot): boolean {
    new Promise((resolve) => {
      this.fairsFacade.fairConfig$.pipe(take(1)).subscribe((fair) => {
        resolve(fair.timezone ?? '+0000');
      });
    }).then((timezone) => {
      const tz: string = <string>timezone;

      const searchTypesFromParam = route.queryParamMap.getAll(SearchResolver.searchTypeParam);
      const searchTermFromParam = route.queryParamMap.get(SearchResolver.searchTermParam);
      const searchPageFromParam = route.queryParamMap.get(SearchResolver.searchPageParam);
      const searchSortParam = route.queryParamMap.get(SearchResolver.searchSortParam);
      const stringFilterParam = route.queryParamMap.get(SearchResolver.searchStringFilterParam);
      const dateFilterParam = route.queryParamMap.get(SearchResolver.searchDateFilterParam);
      let searchTypes = [SearchType.all];
      let searchTerm = '';
      let page = '';
      let searchSort = null;
      let stringFilter = undefined;
      let dateFilter = undefined;

      if (searchTypesFromParam.length > 0) {
        searchTypes = searchTypesFromParam.filter((param) =>
          Object.values(SearchType).includes(param as SearchType)
        ) as SearchType[];
      }

      if (searchTermFromParam) {
        searchTerm = searchTermFromParam;
      }

      if (searchPageFromParam) {
        page = searchPageFromParam;
      }

      switch (searchSortParam) {
        case SearchSortOrder.recommended:
        case SearchSortOrder.alphabeticalAsc:
        case SearchSortOrder.alphabeticalDesc:
        case SearchSortOrder.dateAsc:
        case SearchSortOrder.dateDesc:
        case SearchSortOrder.exhibitionHallsAsc:
        case SearchSortOrder.exhibitionHallsDesc:
          searchSort = searchSortParam;
          break;
        default:
          searchSort = SearchSortOrder.recommended;
      }

      if (stringFilterParam) {
        stringFilter = resolveFilterParam(stringFilterParam);
      }

      if (dateFilterParam) {
        dateFilter = resolveDateFilterParam(dateFilterParam, tz);
      }

      const filters: SearchFilters = {
        searchTypes,
        searchTerm,
        page,
        searchSort,
        stringFilter,
        dateFilter,
      };

      this.searchFacade.searchPageOpened(filters);
    });

    return true;
  }
}
